import React from 'react'
import styled from 'styled-components'

import CopyToClipBoard from 'components/CopyToClipBoard'
import Icon from 'components/Icon'
import Text, { TextProps } from 'components/Text'
import Tooltip from 'components/Tooltip'
import { getApiKeyLastPortion } from './helper'

type CellTextProps = TextProps & {
  children: string
}

type ColumnHeaderProps = CellTextProps

type KeyCellProps = {
  keyValue: string
}

type LeadOwnerCellProps = {
  teamName: string
}

export const CellText: React.FC<CellTextProps> = ({ children, textTransform = 'capitalize', ...props }) => (
  <Text {...props} ellipsis fontSize={14} lineHeight="24px" textTransform={textTransform}>
    {children}
  </Text>
)

export const ColumnHeader: React.FC<ColumnHeaderProps> = ({ children }) => (
  <HeaderText color="gray5" fontSize={14} fontWeight="medium" lineHeight="24px">
    {children}
  </HeaderText>
)

export const KeyCell: React.FC<KeyCellProps> = ({ keyValue }) => (
  <KeyCellWrapper>
    <CellText textTransform="none">{getApiKeyLastPortion(keyValue)}</CellText>
    <Tooltip position="bottom" title="copy_key">
      <CopyToClipBoard icon={['far', 'copy']} iconColor="gray5" clipBoardContent={keyValue} />
    </Tooltip>
  </KeyCellWrapper>
)

export const LeadOwnerCell: React.FC<LeadOwnerCellProps> = ({ teamName }) => (
  <LeadOwnerCellWrapper>
    <Icon color="gray5" icon={['far', 'users']} />
    <CellText>{teamName}</CellText>
  </LeadOwnerCellWrapper>
)

const HeaderText = styled(Text)`
  cursor: pointer;
`

const KeyCellWrapper = styled.div`
  align-items: center;
  display: flex;
  justify-content: 'space-between';
  user-select: none;
`

const LeadOwnerCellWrapper = styled.div`
  align-items: center;
  display: flex;
  gap: 8px;
`
